import React, { FC } from 'react';
import { SettingsCardsPageSkeleton } from '../settings/settingsSkeleton';

export const DashboardAnalyticsPageSkeleton: FC = () => <SettingsCardsPageSkeleton />;
